import isEqual from 'lodash/isEqual';

import buildComponent from './utils/build-component';
import closest from './utils/closest';

export default (nameSpace, selector) => buildComponent({
  nameSpace,
  selector,
  initState: {
    isSlider: false,
    videos: false,
    activeVideo: null,
  },
  initFunction: ($el, params) => {
    const $slides = $el.querySelectorAll(`.${nameSpace}__slide`);
    const $videos =  $el.querySelectorAll(`.${nameSpace}__video-bg`)
    let slider;

    //
    // Methods
    //

    function onLoadedImageSetClasses(isLoaded, $image) {
      if (isLoaded) {
        import(`./utils/closest`).then(module => {
          const $slide = module.default({
            el: $image,
            selector: `.${nameSpace}__slide`,
          });
          $slide.classList.add(`${nameSpace}__slide--image-is-loaded`);
          const $imageBg = module.default({
            el: $image,
            selector: `.${nameSpace}__image-bg`,
          });
          let src = window.innerWidth > window.innerHeight ? $image.src : $image.dataset.srcMobile;
          $imageBg.style.backgroundImage = `url('${src}')`
        })
      }
    }

    function setImagesSrc($list) {
      [...$list].forEach(($image) => {
        import(`./block-img-load`).then(module => {
          setTimeout(() => {
            if ($image.src && $image.naturalWidth && $image.naturalHeight) {
              onLoadedImageSetClasses(true, $image)
            } else {
              let instance;
              if ($image.Component && $image.Component['bloc-img-load']) {
                instance = $image.Component['bloc-img-load'];
              } else {
                instance = module.default(`${nameSpace}__image`).init({ $el: $image });
              }
              instance.addObserver((state) => onLoadedImageSetClasses(state.isLoaded, $image))
              instance.setSrc();
            }
          }, 0);
        })
      })
    }

    function initVideo($list) {
      [...$list].forEach(($videoBg, index) => {
        const $video = $videoBg.querySelector('video');
        const $slide = closest({ el: $videoBg, selector: `.${nameSpace}__slide` });
        $slide.classList.add(`${nameSpace}__slide--is-video`);
        if (typeof $videoBg.VideoJs === 'undefined') {
          import(`./utils/cover-element`).then(module => {
            module.default({
              el: $video,
              container: $videoBg,
            })
            import(/* webpackChunkName: "chunk-videojs" */ `./libs/videojs-youtube`).then(module => {
              $videoBg.VideoJs = module.default($video, {
                controls: false,
                loop: true,
                autoplay: false,
                muted: true,
                loadingSpinner: false,
                preload: 'auto',
              });
              if (!params.getState().isSlider) {
                params.setState({ activeVideo: index });
              }
            })
          });
        }
      })      
    }

    function onSliderInit() {
      setImagesSrc($el.querySelectorAll(`img[data-block-img-load]`));
      if (params.getState().videos) {
        const $duplacatedVideos = $el.querySelectorAll(`.swiper-slide-duplicate .${nameSpace}__video-bg`);
        params.setState(prevState => ({ videos: [...prevState.videos, ...$duplacatedVideos] }))
      }
    }

    function onSlideChange() {
      if (params.getState().videos) {
        const $currentActiveVideo = $el.querySelector(`.swiper-slide-active .${nameSpace}__video-bg`);
        params.setState({ activeVideo: $currentActiveVideo ? params.getState().videos.indexOf($currentActiveVideo) : null})
      }
    }

    function initSlider() {
      import(/* webpackChunkName: "chunk-swiper" */ `swiper`).then(module => {
        const Swiper = module.default;
        slider = new Swiper($el.querySelector('.swiper-container'), {
          autoplay: true,
          loop: true,
          on: {
            init: onSliderInit,
            slideChangeTransitionEnd: onSlideChange,
          }
        });
      })
    }

    function playActiveVideo(index, prevIndex) {
      import(/* webpackChunkName: "chunk-videojs" */ `./libs/videojs-youtube`).then(module => {
        if (index !== null) {
          params.getState().videos[index].VideoJs.play();
        }
        if (prevIndex !== null) {
          params.getState().videos[prevIndex].VideoJs.pause();
        }
      });
    }

    //
    // Life Cycle
    //

    params.onStateUpdate((newState, prevState) => {
      if (!prevState.isSlider && newState.isSlider) {
        initSlider();
      }
      if (!isEqual(prevState.videos, newState.videos)) {
        initVideo(newState.videos);
      }
      if (newState.videos && prevState.activeVideo !== newState.activeVideo) {
        playActiveVideo(newState.activeVideo, prevState.activeVideo )
      }
    });

    //
    // Procedures
    //
    
    if ($videos.length && window.innerWidth > window.innerHeight) {
      params.setState({ videos: [...$videos] });
    }

    if ($slides.length > 1) {
      params.setState({ isSlider: true });
    } else {
      setImagesSrc($el.querySelectorAll(`img[data-block-img-load]`));
    }

    //
    // Listeners / Observers
    //

    //
    // Public API
    //

    return {
    };
  }
});



// WEBPACK FOOTER //
// ./src/scripts/hero-slider.js